import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import Input from 'v3/components/Input';
import Button from 'v3/components/Button';
import TextArea from 'v3/components/TextArea';
import Select from 'v3/components/Select';
import ApplicationLayout from 'v3/layouts/Application';

import {
  getCustomInputValue,
  formatLabelLog,
  formatOptionInput,
  formatOnChange,
  formatInputValue
} from 'v3/pages/BlackList/controller'

import Attachments from 'v3/pages/BlackList/Components/Attachments'

import { Row, Col } from 'react-bootstrap/';

import { useBlacklist } from '../../context';
import { usePermission } from 'hooks';

export function BlacklistRegister() {

  usePermission('CADASTRAR_BLACKLIST', { redirect: true });

  const {
    loading,
    registerBlacklist,
    setData,
    data,
    blacklistType,
    error } = useBlacklist();

  useEffect(() => {
    if (!data?.blacklistType) return;

    setData(old => ({
      ...old,
      person: null,
      wagon: null,
      vehicle: null
    }));
  }, [data?.blacklistType?.id]);

  const CustomInput = ({ setData, data, blacklistType, error }) => {

    const label = formatLabelLog(blacklistType) || 'Selecione o tipo de blacklist *';

    return (
      <Select.Async
        key={data?.blacklistType?.id}
        label={label}
        onSearch={value => getCustomInputValue(value, blacklistType)}
        value={formatInputValue(data, blacklistType)}
        isDisabled={data?.blacklistType ? false : true}
        onChange={value => {
          if (value) {
            const type = formatOnChange(value, blacklistType);
            setData(old => ({ ...old, ...type }));
          } else {
            setData(old => ({
              ...old,
              person: null,
              wagon: null,
              vehicle: null
            }));
          }
        }}
        getOptionLabel={option => formatOptionInput(option, blacklistType)}
        getOptionValue={option => option.id}
        error={error}
      />
    )
  }
  return (
    <ApplicationLayout
      title="Blacklist"
      RightComponent={
        <>
          <Link to="/blacklist">
            <Button variant="secondary" loading={loading}>
              <Text weight={500} color="dark" type="regular">
                Cancelar
              </Text>
            </Button>
          </Link>
          <Button
            variant="success"
            style={{ marginLeft: '10px' }}
            loading={loading}
            onClick={() => {
              registerBlacklist(data);
            }}
          >
            <Text weight={500} color="white" type="regular">
              Salvar
            </Text>
          </Button>
        </>
      }
    >
      <Row>
        <Card
          header={
            <Text color="#464E5F" type="header">
              Cadastro de blacklist
            </Text>
          }
        >
          <Row>
            <Col md={6} xs={12} className="mb-3">
              <Select
                label="Tipo de blacklist *"
                options={blacklistType}
                value={data?.blacklistType}
                getOptionLabel={option => option?.name}
                getOptionValue={option => option?.id}
                onChange={event => {
                  setData(old => ({ ...old, blacklistType: event }));
                }}
                error={error?.blacklistType}
              />
            </Col>
            <Col md={6} xs={12} className="mb-3">
              <CustomInput
                key={data?.blacklistType?.id}
                setData={setData}
                data={data}
                blacklistType={data?.blacklistType?.slug}
                error={error?.personId}
              />
            </Col>

            <Col md={6} xs={12}>
              <Input
                label="Motivo *"
                value={data?.reason}
                onChange={event => setData(old => ({ ...old, reason: event?.target?.value }))}
                error={error?.reason}
              />
            </Col>
            <Col md={6} xs={12}>
              <TextArea
                label="Observação *"
                resizable={false}
                value={data?.description}
                onChange={event => setData(old => ({ ...old, description: event?.target?.value }))}
                error={error?.description}
              />
            </Col>
            <Col>
              <Attachments setData={setData} />
            </Col>
          </Row>
        </Card>
      </Row>
    </ApplicationLayout>
  );
}
